import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';
import { createRoutes } from '@/utils/router-helper';

import MCAFinancingPage from '@/pages/mca/MCAFinancingPage.vue';
import MCAFinancingSpendPage from '@/pages/mca/MCAFinancingSpendPage.vue';
import MCAFinancingAdvancesPage from '@/pages/mca/MCAFinancingAdvancesPage.vue';

export default createRoutes({
  path: 'financing', // MCA Route
  beforeEnter: authGuard,
  meta: {
    displayNav: true,
    isLegacy: true,
  },
  children: [
    {
      path: '', // MCA Route
      alias: '/financing',
      name: RouteNames.MCA.INDEX,
      component: MCAFinancingPage,
    },
    {
      path: 'spend', // MCA Route
      alias: '/financing/spend',
      name: RouteNames.MCA.SPEND,
      component: MCAFinancingSpendPage,
    },
    {
      path: 'advances', // MCA Route
      alias: '/financing/advances',
      name: RouteNames.MCA.ADVANCES,
      component: MCAFinancingAdvancesPage,
    },
  ],
});
